var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle",
      "gutter": [40, 40]
    }
  }, [_c('a-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h1', [_vm._v("FutureAI信息科技学生素养评价系统为教育管理部门和学校提供智能评价服务方案")]), _c('span', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("查看系统演示")])]), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner2.png"),
      "alt": ""
    }
  })])], 1)], 1), _c('div', {
    staticClass: "section"
  }, [_vm._m(0), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("FutureAI信息科技核心素养评价系统适时推出，助力区域信息科技和人工智能教育发展，对中小学生信息科技学生素养发展水平做出专业评价，优化教学成果和方法。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle",
      "gutter": [24, 24]
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mean1.png"),
      "alt": ""
    }
  })])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1 shadow"
  }, [_c('h3', [_vm._v("区域测评")]), _c('p', [_vm._v("评价系统助力教育主管部门通过智能化手段，了解和分析区域信息科技或人工智能教育发展水平，结合专家顾问，便于主管单位决策者推动信息科技教育创新。")])])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1 shadow"
  }, [_c('h3', [_vm._v("选拔测")]), _c('p', [_vm._v("依托FutureAI丰富实测数据，精准定位学生在科技特长方面学习能力层次，为教师差异化教学提供精准指引。")])])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mean2.png"),
      "alt": ""
    }
  })])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mean3.png"),
      "alt": ""
    }
  })])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1 shadow"
  }, [_c('h3', [_vm._v("随堂测")]), _c('p', [_vm._v("帮助教师验证教学目标，改进教学策略，提升教学效果。")])])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1 shadow"
  }, [_c('h3', [_vm._v("单元测")]), _c('p', [_vm._v("同步配套理论综合练习，及时了解学生章节掌握情况，巩固知识点。")])])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mean4.png"),
      "alt": ""
    }
  })])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mean5.png"),
      "alt": ""
    }
  })])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1 shadow"
  }, [_c('h3', [_vm._v("期中测")]), _c('p', [_vm._v("阶段性教学评价，及时发现薄弱环节，优化学习路径。")])])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1 shadow"
  }, [_c('h3', [_vm._v("期末测")]), _c('p', [_vm._v("学生成绩可视化，快速验收学习成效，巩固学习成果。")])])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mean6.png"),
      "alt": ""
    }
  })])])], 1)], 1)])]), _c('div', {
    staticClass: "section section-gray"
  }, [_vm._m(1), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }), _c('div', {
    staticClass: "wrap2"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report1.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report2.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report3.png"),
      "alt": ""
    }
  })])], 1)], 1)])]), _c('div', {
    staticClass: "section"
  }, [_vm._m(2), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("该系统具备人工智能核心素养模型和信息科技学生素养模型将准确测出学生的知识储备、特长发展、学习行为、学习漏洞等多方面的情况做出综合评价，为信息科技课堂教学和区域科技教育发展提供科学依据。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "gutter": [24, 24]
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('h3', [_vm._v("成本省")]), _c('p', [_vm._v("无需复杂的系统部署或大量人力物力投入，网页版服务，一键部署，减少后顾之忧。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('h3', [_vm._v("评价快")]), _c('p', [_vm._v("创建班级，凭学号参加评价，自动批改判卷，实时生成报告。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('h3', [_vm._v("诊断准")]), _c('p', [_vm._v("基于人工智能算法，结合FUTUREAI丰富实测数据，全方位精准诊断学生学情。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('h3', [_vm._v("题量大")]), _c('p', [_vm._v("50000+道信息科技素养试题，1万+套试卷，更有模拟练习资源，均可直接发起普测。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('h3', [_vm._v("分工细")]), _c('p', [_vm._v("覆盖各角色各场景，提升教学管理效率，使管理人员产能最大化。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('h3', [_vm._v("操作易")]), _c('p', [_vm._v("一键发布测评，操作简单便捷，彻底告别繁冗的测评流程。")])])])], 1)], 1)])]), _vm._m(3), _vm._m(4)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("产品意义")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("产品特色")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("产品优势")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("平台支持")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }), _c('div', {
    staticClass: "wrap1"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "1000px"
    },
    attrs: {
      "src": require("../assets/suport.png"),
      "alt": ""
    }
  })])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("考务管理")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }), _c('div', {
    staticClass: "wrap1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/admin3.png"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/admin2.png"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/admin1.png"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/report.png"),
      "alt": ""
    }
  })])])]);
}];
export { render, staticRenderFns };